import { ValueOf } from './generic'

export const FormMode = {
  create: 'create',
  edit: 'edit'
} as const

export type FormMode = ValueOf<typeof FormMode>

export interface AddressToDisplayInterface {
  companyName?: string
  city: string
  postalCode: string
  street: string
  houseNumber: string
}
